import fetchAPI from '../fetchAPI';

export const callDeleteKey = async (id: string): Promise<iResponse<Keys>> => {
  const response: iResponse<Keys> = await fetchAPI({
    method: `DELETE`,
    route: `api-key/${id}`
  });

  // const {error} = response;
  // if (error) throw new ResponseError(error);

  return response;
};

export default callDeleteKey;
